module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_1.5f05082e.png";